import { ref } from 'vue'

/**
 * Wird von pwa.ts gesetzt, sobald die Service-Worker-Registrierung einen
 * wartenden neuen Worker meldet (`onNeedRefresh`). useVersionCheck beobachtet
 * das Signal und stößt sofort einen autoritativen version.json-Check an –
 * das Signal selbst löst nie einen Reload aus.
 *
 * Eigenes Leaf-Modul (statt Export aus pwa.ts), damit Unit-Tests von
 * useVersionCheck den `registerSW`-Seiteneffekt aus pwa.ts nicht importieren
 * müssen und keine Zirkularität pwa.ts ↔ useVersionCheck entsteht.
 */
export const swNeedRefresh = ref(false)
